import { IconAIMagic } from '@components/icons/ai-magic';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { ReviewFindingSummary } from 'api/ai-builder/requests';
import { FindingTargetLabel } from 'ui/journey-builder/review/finding-target-label';

import { UserMessageContainer } from './user-message';

export type UserFindingMessageProps = {
  finding: ReviewFindingSummary;
};

export const UserFindingMessage = ({ finding }: UserFindingMessageProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <UserMessageContainer data-testid="user-finding-message">
      <Stack space={1}>
        <Stack orientation="horizontal" space={1} align="center">
          <IconAIMagic color="aiGradientTeal100" size={16} />
          <Text font="semibold12" color="textSecondary" text={t('fixWithNavigator')} />
        </Stack>
        <Text font="semibold14" color="elementBlue100" text={finding.title} />
        <FindingTargetLabel target={finding.target} />
      </Stack>
    </UserMessageContainer>
  );
};

export const locale = {
  en: {
    fixWithNavigator: 'Fix with Navigator',
  },
};
